export function getImageDimensions(logoUrl, callBack){
    // Créer une nouvelle instance de l'objet Image
    const img = new Image();
    // Attacher un gestionnaire d'événements pour le chargement de l'image
    img.onload = () => callBack(null, img);
    img.onerror = (err) => callBack(err);
    // Définir la source de l'image
    img.src = logoUrl;
};